
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SEOHead from '../../components/base/SEOHead';

const milestones = [
  {
    year: '2012',
    title: 'Kuruluş',
    description: 'Ankara\'da savunma sanayi güvenlik danışmanlığı alanında faaliyetlerimize başladık.',
    icon: 'ri-flag-line'
  },
  {
    year: '2015',
    title: 'İlk 50 Belge',
    description: 'Milli ve NATO TGB alanında 50. başarılı belgelendirme sürecimizi tamamladık.',
    icon: 'ri-award-line'
  },
  {
    year: '2018',
    title: 'Ekip Genişlemesi',
    description: 'Uzman kadromuzu genişleterek daha fazla firmaya hizmet vermeye başladık.',
    icon: 'ri-team-line'
  },
  {
    year: '2021',
    title: '100+ Belge',
    description: 'Tamamlanan belge sayımız 100\'ü aştı, sektörde güvenilir bir marka haline geldik.',
    icon: 'ri-medal-line'
  },
  {
    year: '2024',
    title: '150+ Belge',
    description: '150\'den fazla başarılı belgelendirme ile sektör liderliğimizi pekiştirdik.',
    icon: 'ri-trophy-line'
  }
];

const values = [
  {
    icon: 'ri-shield-check-line',
    title: 'Güvenilirlik',
    description: 'Gizlilik ve güvenlik konusunda en yüksek standartları uyguluyoruz. Müşteri bilgilerinin korunması bizim için önceliktir.'
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Uzmanlık',
    description: '12 yılı aşkın deneyimimiz ve sürekli güncellenen bilgi birikimimizle sektörün en karmaşık süreçlerini yönetiyoruz.'
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Müşteri Odaklılık',
    description: 'Her firmayı benzersiz olarak değerlendiriyor, ihtiyaçlarına özel çözümler sunuyoruz.'
  },
  {
    icon: 'ri-checkbox-circle-line',
    title: 'Şeffaflık',
    description: 'Süreçlerimizi açık ve anlaşılır şekilde yürütüyor, her aşamada sizi bilgilendiriyoruz.'
  }
];

const team = [
  {
    name: 'Mehmet Kaya',
    role: 'Kurucu & Genel Müdür',
    description: 'MSB ve savunma sanayi alanında 20 yılı aşkın deneyim',
    image: 'https://public.readdy.ai/ai/img_res/1562a51ebd53b8a5ec2edd9591f6884f.jpg'
  },
  {
    name: 'Ayşe Demir',
    role: 'Kıdemli Danışman',
    description: 'NATO TGB ve uluslararası belgelendirme uzmanı',
    image: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20businesswoman%20portrait%20woman%20in%20formal%20attire%20confident%20smile%20corporate%20headshot%20neutral%20gray%20background%20warm%20lighting%20high%20quality&width=400&height=500&seq=team-002&orientation=portrait'
  },
  {
    name: 'Ali Yıldız',
    role: 'Fiziki Güvenlik Uzmanı',
    description: 'Güvenlik sistemleri ve altyapı kurulum danışmanı',
    image: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20man%20portrait%20security%20expert%20in%20business%20casual%20confident%20expression%20corporate%20headshot%20neutral%20gray%20background%20warm%20lighting%20high%20quality&width=400&height=500&seq=team-003&orientation=portrait'
  }
];

export default function HakkimizdaPage() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Hakkımızda | TGB Danışmanlık",
      "description": "Tesis Güvenlik Belgesi danışmanlığında 12 yılı aşkın deneyim. Ankara merkezli profesyonel TGB danışmanlık firması.",
      "url": "https://tesisguvenlikbelgesi.com.tr/hakkimizda"
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Tesis Güvenlik Belgesi Danışmanlık",
      "description": "MSB ve NATO Tesis Güvenlik Belgesi danışmanlık hizmetleri",
      "foundingDate": "2012",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Konutkent Mahallesi 3028 Cadde 8C Daire 17",
        "addressLocality": "Çankaya",
        "addressRegion": "Ankara",
        "postalCode": "06810",
        "addressCountry": "TR"
      },
      "telephone": "+903126660636",
      "email": "info@tesisguvenlikbelgesi.com.tr"
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://tesisguvenlikbelgesi.com.tr" },
        { "@type": "ListItem", "position": 2, "name": "Hakkımızda", "item": "https://tesisguvenlikbelgesi.com.tr/hakkimizda" }
      ]
    }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Hakkımızda | TGB Danışmanlık Ankara - Tesis Güvenlik Belgesi"
        description="12 yılı aşkın deneyimle MSB ve NATO Tesis Güvenlik Belgesi danışmanlığı. 150+ başarılı belgelendirme, %96 başarı oranı. Ankara merkezli profesyonel TGB danışmanlık."
        keywords="TGB danışmanlık hakkında, tesis güvenlik belgesi danışmanlık firması, Ankara TGB uzmanı, MSB belgelendirme danışmanı, savunma sanayi güvenlik"
        canonicalUrl="https://tesisguvenlikbelgesi.com.tr/hakkimizda"
        structuredData={structuredData}
      />
      <Navbar onNavClick={handleNavClick} />

      {/* Hero Section */}
      <section className="relative pt-32 pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20corporate%20office%20interior%20professional%20consulting%20firm%20meeting%20room%20with%20large%20windows%20cityscape%20view%20warm%20sunset%20lighting%20elegant%20minimalist%20design%20Turkish%20business%20atmosphere&width=1920&height=700&seq=hakkimizda-hero-001&orientation=landscape"
            alt="TGB Danışmanlık Hakkımızda"
            loading="eager"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-3xl">
            <div className="inline-block px-4 py-2 bg-orange-500/20 backdrop-blur-sm rounded-full border border-orange-400/30 mb-6">
              <span className="text-sm font-medium text-orange-300">Kurumsal</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Güvenliğiniz İçin<br />
              <span className="text-orange-400">12 Yıllık</span> Deneyim
            </h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Savunma sanayi güvenlik belgelendirme süreçlerinde Türkiye\'nin önde gelen danışmanlık firmalarından biri olarak, firmanızın gizlilik dereceli projelere katılımını en yüksek standartlarda gerçekleştiriyoruz.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/ucretsiz-on-degerlendirme"
                className="px-8 py-4 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Ücretsiz Ön Değerlendirme
              </Link>
              <Link
                to="/iletisim"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-lg font-semibold hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                İletişime Geçin
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white relative -mt-12 z-10">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-white rounded-2xl shadow-xl p-8 grid grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { value: '150+', label: 'Tamamlanan Belge', icon: 'ri-file-check-line', color: 'bg-teal-100 text-teal-600' },
              { value: '12', label: 'Yıllık Deneyim', icon: 'ri-calendar-check-line', color: 'bg-orange-100 text-orange-600' },
              { value: '%96', label: 'Başarı Oranı', icon: 'ri-bar-chart-box-line', color: 'bg-emerald-100 text-emerald-600' },
              { value: '80+', label: 'Mutlu Müşteri', icon: 'ri-building-line', color: 'bg-amber-100 text-amber-600' },
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className={`w-14 h-14 ${stat.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                  <i className={`${stat.icon} text-2xl`}></i>
                </div>
                <div className="text-4xl font-bold text-gray-900 mb-1">{stat.value}</div>
                <div className="text-gray-600 text-sm font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-24 px-6 bg-[#FAF8F5]">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20business%20team%20collaboration%20meeting%20modern%20office%20environment%20Turkish%20corporate%20setting%20warm%20lighting%20teamwork%20discussion%20strategic%20planning%20elegant%20interior&width=700&height=500&seq=hakkimizda-mission-001&orientation=landscape"
                  alt="TGB Danışmanlık Ekibi"
                  className="w-full h-[500px] object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="absolute -bottom-8 -right-8 bg-orange-500 text-white p-8 rounded-2xl shadow-xl max-w-xs">
                <div className="text-5xl font-bold mb-2">2012</div>
                <div className="text-orange-100">yılından bu yana hizmetinizdeyiz</div>
              </div>
            </div>

            {/* Right - Content */}
            <div>
              <p className="text-orange-500 text-sm font-semibold uppercase tracking-wider mb-3">Biz Kimiz</p>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Misyonumuz ve Vizyonumuz</h2>
              
              <div className="space-y-8">
                <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-teal-500">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-3">
                    <i className="ri-focus-3-line text-teal-500 text-2xl"></i>
                    Misyonumuz
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    Savunma sanayi firmalarının MSB ve NATO Tesis Güvenlik Belgesi süreçlerini en verimli şekilde yönetmek, gizlilik dereceli projelere katılımlarını hızlandırmak ve güvenlik standartlarını en üst düzeyde sağlamaktır.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-orange-500">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-3">
                    <i className="ri-eye-line text-orange-500 text-2xl"></i>
                    Vizyonumuz
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    Türkiye\'nin savunma sanayi güvenlik belgelendirme alanında en güvenilir ve tercih edilen danışmanlık firması olmak, sektörde standartları belirleyen öncü kuruluş konumunu sürdürmektir.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-orange-500 text-sm font-semibold uppercase tracking-wider mb-3">Değerlerimiz</p>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Bizi Farklı Kılan Değerler</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Her projede bu temel değerlerimizi ön planda tutarak müşterilerimize en iyi hizmeti sunuyoruz
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300 group hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-orange-500 transition-colors">
                  <i className={`${value.icon} text-3xl text-orange-500 group-hover:text-white transition-colors`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-24 px-6 bg-[#FAF8F5]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-orange-500 text-sm font-semibold uppercase tracking-wider mb-3">Ekibimiz</p>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Uzman Kadromuz</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Alanında uzman, deneyimli ve profesyonel ekibimizle yanınızdayız
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {team.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group"
              >
                <div className="h-80 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-orange-500 font-medium mb-3">{member.role}</p>
                  <p className="text-gray-600 text-sm">{member.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-orange-500 text-sm font-semibold uppercase tracking-wider mb-3">Tarihçemiz</p>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Yolculuğumuz</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              2012\'den bugüne kadar geçen süreçte elde ettiğimiz başarılar
            </p>
          </div>

          <div className="relative">
            {/* Timeline Line */}
            <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gray-200 -translate-y-1/2"></div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
              {milestones.map((milestone, index) => (
                <div key={index} className="relative">
                  {/* Timeline Dot */}
                  <div className="hidden lg:flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 bg-orange-500 rounded-full border-4 border-white shadow-lg z-10"></div>
                  
                  <div className={`bg-gray-50 rounded-2xl p-6 text-center hover:shadow-lg transition-all ${index % 2 === 0 ? 'lg:mb-32' : 'lg:mt-32'}`}>
                    <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className={`${milestone.icon} text-2xl text-orange-500`}></i>
                    </div>
                    <div className="text-2xl font-bold text-orange-500 mb-2">{milestone.year}</div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{milestone.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{milestone.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-24 px-6 bg-gradient-to-br from-gray-900 to-gray-800">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-orange-400 text-sm font-semibold uppercase tracking-wider mb-3">Neden Biz?</p>
              <h2 className="text-4xl font-bold text-white mb-6">Neden TGB Danışmanlık?</h2>
              <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                Savunma sanayi güvenlik belgelendirme süreçlerinde edindiğimiz deneyim ve uzmanlıkla, firmanızın ihtiyaçlarına en uygun çözümleri sunuyoruz.
              </p>

              <div className="space-y-6">
                {[
                  { icon: 'ri-time-line', title: 'Hızlı Süreç Yönetimi', desc: 'Ortalama 6-12 ay içinde belge teslimi' },
                  { icon: 'ri-customer-service-2-line', title: '7/24 Destek', desc: 'Süreç boyunca kesintisiz iletişim' },
                  { icon: 'ri-money-dollar-circle-line', title: 'Şeffaf Fiyatlandırma', desc: 'Gizli maliyet yok, net teklifler' },
                  { icon: 'ri-verified-badge-line', title: 'Garantili Hizmet', desc: '%96 başarı oranı ile güvence' },
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-2xl text-orange-400`}></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-white mb-1">{item.title}</h3>
                      <p className="text-gray-400">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20handshake%20business%20partnership%20agreement%20corporate%20meeting%20Turkish%20business%20people%20formal%20attire%20warm%20lighting%20success%20celebration%20elegant%20office%20background&width=600&height=700&seq=hakkimizda-why-001&orientation=portrait"
                alt="TGB Danışmanlık İş Ortaklığı"
                className="rounded-2xl shadow-2xl w-full h-[600px] object-cover object-top"
                loading="lazy"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center">
                    <i className="ri-thumb-up-line text-3xl text-teal-600"></i>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-gray-900">%96</div>
                    <div className="text-gray-600 text-sm">Müşteri Memnuniyeti</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-700">
        <div className="max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl font-bold mb-6">
            Birlikte Çalışalım
          </h2>
          <p className="text-xl text-teal-100 mb-8">
            Tesis Güvenlik Belgesi sürecinizde yanınızda olmak için hazırız. Ücretsiz ön değerlendirme ile başlayalım.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link
              to="/ucretsiz-on-degerlendirme"
              className="px-8 py-4 bg-white text-teal-600 rounded-lg font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Ücretsiz Ön Değerlendirme
            </Link>
            <Link
              to="/iletisim"
              className="px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold hover:bg-teal-400 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              İletişim
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
